import React from 'react';
import Backend from '../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import AlarmList from './helpers/AlarmList';
import AvailableGroups from './helpers/AvailableGroups';
import { Alert, Button } from '../../UI/Common';
import CurrentMeasurementValue from './helpers/CurrentMeasurementValue';
import MobileToggle from '../../UI/MobileToggle';

const DashboardPage = (props) => {
  const { t, errors, alarmList, availableGroups, sensors, groupId } = props;
  function getGroupName() {
    if (groupId && availableGroups.length) {
      return availableGroups.filter(
        (group) => group.groupId.toString() === groupId,
      )[0].groupName;
    }
    return null;
  }
  function getGroupState() {
    if (groupId && availableGroups.length) {
      const { state } = availableGroups.filter(
        (group) => group.groupId.toString() === groupId,
      )[0];
      return state ? 'At rest' : 'In operation';
    }
    return null;
  }
  return (
    <Backend>
      <div className="content-inner" style={{ paddingTop: 10 }}>
        <Alert.Error text={errors} />
        <div className="mb-10">
          <AlarmList
            alarmList={
              groupId
                ? alarmList.filter((al) => al.groupId.toString() === groupId)
                : alarmList
            }
            groupName={getGroupName()}
            groupState={getGroupState()}
            onSelect={props.shouldFetchData}
            groupId={groupId}
            shouldRenderBackBtn={groupId && availableGroups.length !== 1}
            onBack={props.onBack}
          />
        </div>
        <div className="mb-10">
          {groupId ? (
            <CurrentMeasurementValue
              groupId={groupId}
              sensors={sensors}
              onDisableSensor={(params) => props.onDisableSensor(params, 'cmv')}
              onEnableSensor={(selectedGroups) =>
                props.onEnableSensor(selectedGroups, 'cmv')
              }
            />
          ) : (
            <AvailableGroups
              availableGroups={availableGroups}
              onAtRest={props.onAtRest}
              onInOperation={props.onInOperation}
              onDisableSensor={(params) =>
                props.onDisableSensor(params, 'group')
              }
              onEnableSensor={(selectedGroups) =>
                props.onEnableSensor(selectedGroups, 'group')
              }
            />
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <MobileToggle
            isMobile={props.isMobile}
            setIsMobile={props.setIsMobile}
          />
          <span>
            {t('Last Updated')}: {props.lastUpdated}
          </span>
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(DashboardPage);
